import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type UpdateWorksiteInput, updateWorksite } from "@/adapters/api";

export function useUpdateCanteiro(id: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (input: UpdateWorksiteInput) => {
			if (!id) throw new Error("missing worksite id");
			return updateWorksite(id, input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["canteiros"] });
			queryClient.invalidateQueries({ queryKey: ["worksite", id] });
		},
	});
}
